import {
  PaginatedResponse,
  PartnerAffiliateItem,
  PartnerAffiliation,
  PartnerCommission,
  PartnerProduct,
  PartnerWalletResponse,
} from '@/@types/PartnerProgram';
import { api } from './api';

async function getPartnerProducts(
  params?: { per_page?: number; page?: number },
): Promise<PaginatedResponse<PartnerProduct>> {
  const response = await api.get('/v1/partner-products', { params });
  return response.data;
}

async function getPartnerLinks(
  productUuid: string,
): Promise<PaginatedResponse<PartnerAffiliation>> {
  const response = await api.get(
    `/v1/products/${productUuid}/partner-links`,
  );
  return response.data;
}

async function generatePartnerLink(
  productUuid: string,
): Promise<{ data: PartnerAffiliation }> {
  const response = await api.post(
    `/v1/products/${productUuid}/partner-links`,
  );
  return response.data;
}

async function getPartnerCommissions(params?: {
  status?: string;
  affiliate_uuid?: string;
  per_page?: number;
  page?: number;
  currency?: string;
}): Promise<PaginatedResponse<PartnerCommission>> {
  const response = await api.get('/v1/partner-commissions', { params });
  return response.data;
}

async function getPartnerWallet(
  currency?: string,
): Promise<PartnerWalletResponse> {
  const response = await api.get('/v1/partner-wallet', {
    params: { currency },
  });
  return response.data;
}

async function getPartnerAffiliates(params?: {
  only_active?: boolean;
  per_page?: number;
  page?: number;
  currency?: string;
}): Promise<PaginatedResponse<PartnerAffiliateItem>> {
  const response = await api.get('/v1/partner-commissions/affiliates', {
    params,
  });
  return response.data;
}

export const PartnerLinksService = {
  getPartnerProducts,
  getPartnerLinks,
  generatePartnerLink,
  getPartnerCommissions,
  getPartnerWallet,
  getPartnerAffiliates,
};
